import MarkDownRenderer from '../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
# 🗂️ Collection Variables

Collection variables are user-defined key-value pairs scoped at the collection level. They are accessible to all requests, scripts, and flows defined within the same collection.

These variables are particularly useful for storing shared data such as base URLs, tokens, or default request parameters that apply across all requests in a collection. Instead of hardcoding values or repeating them in every request, you can define them once here and reuse using the double curly braces syntax like \`{{baseUrl}}\`.

Collection variables are stored alongside the collection file (in YAML) and are easily trackable and version-controlled with Git.

**Example use case:** If your API base URL is \`https://api.example.com\`, you can define a variable \`baseUrl\` here, and use \`{{baseUrl}}\` in all your endpoints.

![Collection Variables](/docs/collectionVariables.png)

Variable precedence determines which variable is used when there are duplicates across different scopes. In HawkClient, the order of precedence is:

1. **Request Variables**
2. **Environment Variables**
3. **Collection Variables**
4. **Global Variables**

This means Collection Variables will override Global Variables, but will be overridden by Environment or Request-specific variables if present.
`;

const CollectionVariables = () => {
    return (
        <MarkDownRenderer
            title="Collection Variables"
            markDownText={markdownContent}
        />
    );
};

export default CollectionVariables;
